<template>
<svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.9984 4L15.7179 10.3333V4L7.45404 12" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M22.0002 4.4V4V20" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2.00085 12.2V12V20" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.31763 12H7.45398H1.99983" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2.50082 19.9999H2.00085H21.9994" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: '24'
        },
        color: {
            type: String,
            default: '#021B51'
        },
    }
}
</script>